import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-net-lookup',
  templateUrl: './micro-net-lookup.component.html'
})
export class MicroNetLookupComponent  {

  @Input()
  netId:any;

  @Input()
  link:boolean = true;
}
